module.exports = __webpack_public_path__ + "static/media/volkswagen_2019_logo.299bef30.png";